<template>
    <!-- Unfortunately we can't go full BEM here, swiperjs needs its classes to properly work -->
    <div class="swiper-gallery grid grid__base">
        <div class="swiper-container" ref="gallery">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(image, imageIdx) in images" :key="imageIdx">
                    <figure class="swiper-gallery--figure">
                        <div class="swiper-gallery--ratio-wrap-outer">
                            <div class="swiper-gallery--ratio-wrap-inner">
                                <component class="swiper-gallery--image-button"
                                        :is="allowOverlay ? 'button' : 'div'"
                                        @click="onGalleryRequested(imageIdx)">
                                    <picture-element class="swiper-gallery--image" v-bind="image"/>
                                    <div class="swiper-gallery--open-gallery" v-if="allowOverlay">
                                        <ui-icon symbol="plus" size="medium" :dynamic-size="true"/>
                                    </div>
                                </component>
                            </div>
                        </div>
                        <figcaption class="swiper-gallery--description">
                            <component class="u-reset swiper-gallery--conditional-link"
                                    v-bind="getLinkProps(image)"
                                    :is="image.href ? 'a' : 'span'">
                                {{ image.caption }}
                            </component>
                        </figcaption>
                    </figure>
                </div>
            </div>
        </div>
        <div class="swiper-gallery--buttons" v-if="images.length > 1">
            <div class="swiper-gallery--ratio-wrap-outer">
                <div class="swiper-gallery--ratio-wrap-inner">
                    <div class="swiper-gallery--buttons-inner">
                        <div class="swiper-gallery--nav swiper-gallery--nav__prev">
                            <button class="swiper-gallery--btn btn btn__secondary btn__square btn__medium" ref="prevButton">
                                <div class="swiper-gallery--btn-content btn--wrap">
                                    <ui-icon symbol="chevron-left" size="small"/>
                                </div>
                            </button>
                        </div>
                        <div class="swiper-gallery--nav swiper-gallery--nav__next">
                            <button class="swiper-gallery--btn btn btn__secondary btn__square btn__medium" ref="nextButton">
                                <div class="swiper-gallery--btn-content btn--wrap">
                                    <ui-icon symbol="chevron-right" size="small"/>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper';
    import { mapActions } from 'vuex';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import PictureElement from 'framework/components/picture-element/picture-element';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';

    export default {
        components: {
            PictureElement,
            UiIcon,
        },
        mixins: [
            bemMixin('swiper-gallery'),
        ],
        props: {
            allowOverlay: {
                type: Boolean,
                default: true,
            },
            /** @type IImageSet[] */
            images: {
                type: Array,
                required: true,
            },
            initialIdx: {
                type: Number,
                default: 0,
            },
        },
        methods: {
            ...mapActions('project-status', ['toggleGalleryOverlay']),
            getLinkProps({ href }) {
                if (href) {
                    return {
                        href,
                        target: '_blank',
                        rel: 'noopener noreferrer',
                    };
                }

                return {};
            },
            initGallery() {
                this.swiper = new Swiper(this.$refs.gallery, {
                    centeredSlides: true,
                    spaceBetween: 10,
                    initialSlide: this.initialIdx,
                    slidesPerGroup: 1,

                    slidesPerColumn: 1,
                    slidesPerView: 1,

                    autoHeight: true,
                    grabCursor: true,

                    // Navigation arrows
                    navigation: {
                        nextEl: this.$refs.nextButton,
                        prevEl: this.$refs.prevButton,
                        disabledClass: 'swiper-gallery--btn__disabled',
                    },
                });
            },
            onGalleryRequested(imageIdx) {
                if (this.allowOverlay) {
                    this.toggleGalleryOverlay({ images: this.images, open: true, imageIdx });
                }
            },
        },
        mounted() {
            this.$nextTick(this.initGallery);
        },
    };
</script>
